import type { MerchantDetailData } from '../hooks/useMerchantDetail';
import type { MerchantKycDetail } from '../services/merchantKycService';

function isKycApprovedStatus(status?: string | null): boolean {
  return status === 'approved' || status === 'completed';
}

function isPackagePaymentPending(status?: string | null): boolean {
  return status === 'pending' || status == null || status === '';
}

export function canAdminSkipKycPackagePayment(
  merchant: MerchantDetailData | null | undefined,
  kycDetail?: MerchantKycDetail | null
): boolean {
  if (!merchant) return false;

  const kycStatus =
    kycDetail?.status ??
    merchant.kycStatus ??
    merchant.onboarding?.status ??
    null;
  const packagePaymentStatus =
    kycDetail?.packagePaymentStatus ??
    merchant.packagePaymentStatus ??
    merchant.onboarding?.packagePaymentStatus ??
    null;

  const kycApproved =
    kycDetail?.status != null
      ? isKycApprovedStatus(kycDetail.status)
      : merchant.isKycApproved === true ||
        merchant.onboarding?.isKycApproved === true ||
        isKycApprovedStatus(kycStatus);

  const paymentPending =
    merchant.isPackagePaymentSatisfied === false ||
    merchant.onboarding?.isPackagePaymentSatisfied === false ||
    isPackagePaymentPending(packagePaymentStatus);

  return kycApproved && paymentPending;
}
